// extracted by mini-css-extract-plugin
export var linkWrap = "ButtonsCubeSection-module--linkWrap--Z1w3n";